import { render, staticRenderFns } from "./RichtextWidget.vue?vue&type=template&id=53f3d45d&scoped=true&"
import script from "./RichtextWidget.vue?vue&type=script&lang=js&"
export * from "./RichtextWidget.vue?vue&type=script&lang=js&"
import style0 from "./RichtextWidget.vue?vue&type=style&index=0&id=53f3d45d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f3d45d",
  null
  
)

export default component.exports